import { render, staticRenderFns } from "./certIntro.vue?vue&type=template&id=45da299f&scoped=true"
import script from "./certIntro.vue?vue&type=script&lang=js"
export * from "./certIntro.vue?vue&type=script&lang=js"
import style0 from "./certIntro.vue?vue&type=style&index=0&id=45da299f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45da299f",
  null
  
)

export default component.exports